import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { getKnowledgeBaseUrl } from 'ui-addon-i18n/internal/utils/getLangCodeSpecificUrls';
import { TrackedLink } from '../../../utils/UsageTracking/TrackedLink';
import { jsx as _jsx } from "react/jsx-runtime";
const CREDITS_KB_URL = 'https://knowledge.hubspot.com/account-management/understand-hubspot-credits-and-billing';
const DEFAULT_MESSAGE_KEY = 'global.learnMore';
export const LearnMoreLink = ({
  usageTracker,
  componentName,
  screen,
  subscreen,
  dataTestId,
  use,
  messageKey = DEFAULT_MESSAGE_KEY
}) => {
  const localizedUrl = getKnowledgeBaseUrl(CREDITS_KB_URL);
  if (usageTracker && componentName && screen) {
    return /*#__PURE__*/_jsx(TrackedLink, {
      "data-test-id": dataTestId,
      external: true,
      href: localizedUrl,
      usageTracker: usageTracker,
      componentName: componentName,
      screen: screen,
      subscreen: subscreen,
      use: use,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: messageKey
      })
    });
  }
  return /*#__PURE__*/_jsx(Link, {
    href: localizedUrl,
    use: use,
    external: true,
    "data-test-id": dataTestId,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: messageKey
    })
  });
};